import React, {useEffect, useState, Fragment, useRef} from 'react'
import {Card,Col,Container,Form,Row} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import { LoadingComponent } from 'recupero-comunes'
import 'recupero-comunes/dist/index.css'
import {limpiarRefAction, obtenerComboCorte, obtenerComboTribunales} from '../../../../store/actions/proceso-judicial-action'
import Mensajes from '../../../mensajes'

const Antecedentes = ({formik, setIsHito, setIsAudiencia,setShowToast, showToast, limpiarREF}) => {
    const [loading, setLoading]=useState(false)  
    const fileRef = useRef();
    const data_proceso_extrajudicial = useSelector((state) => state.procesoExtrajudicialReducer)
    const {datosGestionImplicado} = data_proceso_extrajudicial
    const data_judicial = useSelector((state) => state.procesoJudicialReducer)
    const { cfg_form21, comboCompetencia, datosAntecedentesJudiciales, comboCorte, comboTribunales, comboLibros, comboHitoJudicial, respuestaJudicial, cleanRef} = data_judicial
    
    const [idCarpetaResExt, setIdCarpetaResExt] = useState('')
    const [fechaAudiencia, setFechaAudiencia] = useState('')

    const [codHitoContacto, setCodHitoContacto] = useState('')
    const [minutaHitoContacto, setMinutaHitoContacto] = useState('')
    const [fechaHitoContacto, setFechaHitoContacto] = useState('')

    const [open, setOpen] = React.useState(false)
    const [hidden, setHidden] = React.useState(false)

    const [competencia, setCompetencia] = useState('')
    const [corte, setCorte] = useState('')
    const [tribunal, setTribunal] = useState('')
    const [libro, setLibro] = useState('')
    const [rol, setRol] = useState('')
    const [fechaIngresoCausa, setFechaIngresoCausa] = useState('')
    const [codHitoJudicial, setCodHitoJudicial] = useState('')
    const [fechaHitoJudicial, setFechaHitoJudicial] = useState('')
    const [minutaHitoJudicial, setMinutaHitoJudicial] = useState('')
    const [fechaSiniestro, setFechaSiniestro] = useState('')
    const [fechaUltimoJudicial, setFechaUltimoJudicial] = useState('')
    const [indAudiencia, setIndAudiencia] = useState(0)
    
    const dispatch = useDispatch()
    useEffect(()=>{
        if(cleanRef){
            fileRef.current.value = "";
            setCodHitoJudicial('')
            setFechaAudiencia('')
            setFechaHitoJudicial('')
            dispatch(limpiarRefAction(false))
        }
    },[cleanRef])
    useEffect(() => {
        setIsAudiencia(indAudiencia === 1)
    }, [indAudiencia])
    useEffect(() => {
        setFechaSiniestro(datosGestionImplicado && datosGestionImplicado.datosGestionImplicado[0]['fechaSiniestroFormat'])

    }, [datosGestionImplicado])
    useEffect(() => {
        if (datosAntecedentesJudiciales && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0] === undefined) {
            return
        } else {

            if (datosAntecedentesJudiciales && datosAntecedentesJudiciales ?. datosAntecedentesJudiciales[0]['idCompetencia'] !== undefined && datosAntecedentesJudiciales ?. datosAntecedentesJudiciales[0]['idCompetencia'] !== null && datosAntecedentesJudiciales ?. datosAntecedentesJudiciales[0]['idCompetencia'] !== '') {
                setLoading(true)
                let miConcepto = comboCompetencia && comboCompetencia.comboCompetencia.find(c => c.id === parseInt(datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idCompetencia'])).accion
                
                let query = Buffer.from(JSON.stringify({"concepto": miConcepto})).toString('base64');
                dispatch(obtenerComboCorte(query))
                .then(()=>{
                    setCorte(datosAntecedentesJudiciales &&  parseInt(datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idCorte']))
                })
                .then(()=>setLoading(false));
            }
            if (datosAntecedentesJudiciales && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idCompetencia'] !== undefined && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idCompetencia'] !== null && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idCompetencia'] !== '' && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idCorte'] !== undefined && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idCorte'] !== null && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idCorte'] !== '') {
                setLoading(true)

                let MyIdCompetencia = parseInt(datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idCompetencia'])
                let MyIdCorte = parseInt(datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idCorte'])

                let query = Buffer.from(JSON.stringify({"idCompetencia": MyIdCompetencia, "idCorte": MyIdCorte})).toString('base64');
                dispatch(obtenerComboTribunales(query)).then(()=>setLoading(false));
            }
        }

       
    }, [datosAntecedentesJudiciales,comboCompetencia])
    useEffect(() => {
        setCompetencia(datosAntecedentesJudiciales && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0] !== undefined && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idCompetencia'] !== undefined && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idCompetencia'] !== null && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idCompetencia'] !== '' ? parseInt(datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idCompetencia']) : '')
        
        setTribunal(datosAntecedentesJudiciales && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0] !== undefined && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idTribunalJuz'] !== undefined && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idTribunalJuz'] !== null && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idTribunalJuz'] !== '' ? parseInt(datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idTribunalJuz']) : '')
        setRol(datosAntecedentesJudiciales && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0] !== undefined && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['rolCausa'] !== undefined && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['rolCausa'] !== null && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['rolCausa'] !== '' ? datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['rolCausa'] : '')
        setFechaIngresoCausa(datosAntecedentesJudiciales && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0] !== undefined && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['fecIngresaCausaFormat'] !== undefined && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['fecIngresaCausaFormat'] !== null && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['fecIngresaCausaFormat'] !== '' ? convertirFecha(datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['fecIngresaCausaFormat']) : '')
        setLibro(datosAntecedentesJudiciales && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0] !== undefined && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idLibro'] !== undefined && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idLibro'] !== null && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idLibro'] !== '' ? datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idLibro'] : '')
        setFechaUltimoJudicial(datosAntecedentesJudiciales && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0] !== undefined && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idLibro'] !== undefined && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idLibro'] !== null && datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idLibro'] !== '' ? datosAntecedentesJudiciales.datosAntecedentesJudiciales[0]['idLibro'] : '')


    }, [datosAntecedentesJudiciales])

    const convertirFecha = (fecha) => {
        if (fecha !== null && typeof fecha !== undefined) {
            const [dia, mes, ano] = fecha ?. split('-')
            const fechaFormat = [ano, mes, dia].join('-')

            return fechaFormat
        } else 
            return null
        
    }
    const handleOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }
    const hoy = () => {
        const fecha = new Date()
        const hoy = fecha.toISOString().split('T')[0]
        return hoy
    }
    const handleCloseToast = () => {
        setShowToast(false);
    }
    return (
        <>
            <style type='text/css'>
                {`
    .btn-subir {
      background-color: #00aeab;
      color: #FFFFFF;   
      height:40px;

    }
    .btn-subir:hover{
        background-color:#01cec8;
        color: #FFFFFF;
        
    } 
    
    `} </style>
            <LoadingComponent show={loading}/>

            <Card>
                <Card.Header className='mt-0 mb-0' as='h6'
                    style={
                        {
                            backgroundColor: '#4F517A',
                            color: 'white'
                        }
                }>
                    {
                    cfg_form21 ? cfg_form21.cfg_form21['antecjudiciales-title-antecjudi'] : ''
                } </Card.Header>
                <Container>
                    <Container> {
                        cfg_form21 ? (
                            <div>

                                <Row>
                                    <Col md='2'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form21.cfg_form21['antecjudiciales-cmb-competencia'] + " *"
                                        } </Form.Label>
                                        {' '}
                                        <br/>
                                        <Form.Select className='mt-2' aria-label='Default select example'
                                            onChange={
                                                (e) => {
                                                    formik.handleChange(e)
                                                    setCompetencia(e.target.value)
                                                    if (comboCompetencia && e.target.value !== '') {
                                                        setLoading(true)
                                                        const myConcepto = comboCompetencia.comboCompetencia.find(c => c.id === parseInt(e.target.value)).accion

                                                        let query = Buffer.from(JSON.stringify({"concepto": myConcepto})).toString('base64');
                                                        dispatch(obtenerComboCorte(query)).then(()=>setLoading(false));
                                                    }
                                                    setCorte('')
                                                    setTribunal('')
                                                }
                                            }
                                            name='competencia'
                                            value={
                                                (formik.values.competencia = competencia)
                                            }
                                            error={
                                                formik.errors.competencia
                                        }>
                                            <option value={''}>Seleccione...</option>
                                            {
                                            comboCompetencia && comboCompetencia.comboCompetencia ?. map((c) => (
                                                <option key={
                                                        c.id
                                                    }
                                                    value={
                                                        c.id
                                                }>
                                                    {
                                                    c.nombre
                                                } </option>
                                            ))
                                        } </Form.Select>
                                        {
                                        formik.errors.competencia ? (
                                            <Form.Text variant='danger'
                                                style={
                                                    {color: 'red'}
                                            }>
                                                {
                                                formik.errors.competencia
                                            } </Form.Text>
                                        ) : ('')
                                    } </Col>
                                    <Col md='4'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form21.cfg_form21['antecjudiciales-cmb-corte'] + ' *'
                                        } </Form.Label>
                                        <br/>
                                        <Form.Select className='mt-2' aria-label='Default select example'
                                            onChange={
                                                (e) => {
                                                    formik.handleChange(e)
                                                    setCorte(e.target.value)
                                                    if (e.target.value !== '') {
                                                        setLoading(true)
                                                        let query = Buffer.from(JSON.stringify({"idCompetencia": competencia, "idCorte": e.target.value})).toString('base64')
                                                        dispatch(obtenerComboTribunales(query)).then(()=>setLoading(false))
                                                        setTribunal('')
                                                    }
                                                }
                                            }
                                            name='corte'
                                            value={
                                                (formik.values.corte = corte)
                                            }
                                            error={
                                                formik.errors.corte
                                        }>
                                            <option value={''}>Seleccione...</option>
                                            {
                                            comboCorte && comboCorte.comboCorte ?. map((c) => (
                                                <option key={
                                                        c.id
                                                    }
                                                    value={
                                                        c.id
                                                }>
                                                    {
                                                    c.nombre
                                                } </option>
                                            ))
                                        } </Form.Select>
                                        {
                                        formik.errors.corte ? (
                                            <Form.Text variant='danger'
                                                style={
                                                    {color: 'red'}
                                            }>
                                                {
                                                formik.errors.corte
                                            } </Form.Text>
                                        ) : ('')
                                    } </Col>
                                    <Col md='4'>
                                        <Form.Label className='mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form21.cfg_form21['antecjudiciales-cmb-tribunal'] + " *"
                                        } </Form.Label>
                                        <br/>
                                        <Form.Select aria-label='Default select example'
                                            onChange={
                                                (e) => {
                                                    formik.handleChange(e)
                                                    setTribunal(e.target.value)
                                                }
                                            }
                                            name='tribunal'
                                            value={
                                                (formik.values.tribunal = tribunal)
                                            }
                                            error={
                                                formik.errors.tribunal
                                        }>
                                            <option value={''}>Seleccione...</option>
                                            {
                                            comboTribunales && comboTribunales.comboTribunales ?. map((c) => (
                                                <option key={
                                                        c.id
                                                    }
                                                    value={
                                                        c.id
                                                }>
                                                    {
                                                    c.nombre
                                                } </option>
                                            ))
                                        } </Form.Select>
                                        {
                                        formik.errors.tribunal ? (
                                            <Form.Text variant='danger'
                                                style={
                                                    {color: 'red'}
                                            }>
                                                {
                                                formik.errors.tribunal
                                            } </Form.Text>
                                        ) : ('')
                                    } </Col>

                                    <Col md='1'></Col>
                                </Row>
                                <Row>
                                    <Col md='2'>
                                        <Form.Label className='mb-0 mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form21.cfg_form21['antecjudiciales-cmb-libro']
                                        } </Form.Label>
                                        {' '}
                                        <br/>
                                        <Form.Select className='mt-2 w-75' aria-label='Default select example'
                                            onChange={
                                                (e) => {
                                                    formik.handleChange(e)
                                                    setLibro(e.target.value)
                                                }
                                            }
                                            name='tipoVehiculoIM'
                                            value={
                                                (formik.values.libro = libro)
                                            }
                                            error={
                                                formik.errors.libro
                                        }>
                                            <option value={''}>Seleccione...</option>
                                            {
                                            comboLibros && comboLibros.comboLibros ?. filter((c) => c.agrupacion === parseInt(competencia)).map((c) => (
                                                <option key={
                                                        c.id
                                                    }
                                                    value={
                                                        c.id
                                                }>
                                                    {
                                                    c.nombre
                                                } </option>
                                            ))
                                        } </Form.Select>

                                    </Col>
                                    <Col md='4'>
                                        <Form.Label className='mt-3'
                                            style={
                                                {
                                                    fontWeight: 'bold',
                                                    fontSize: '14px'
                                                }
                                        }>
                                            {
                                            cfg_form21.cfg_form21['antecjudiciales-input-rol'] + ' *'
                                        } </Form.Label>
                                        <br/>
                                        <Form.Control className='mb-0'
                                            value={
                                                (formik.values.rol = rol)
                                            }
                                            name='patenteIM'
                                            onChange={
                                                (e) => {
                                                    formik.handleChange(e)
                                                    setRol(e.target.value)
                                                }
                                            }
                                            error={
                                                formik.errors.rol
                                        }></Form.Control>
                                    {
                                    formik.errors.rol ? (
                                        <Form.Text variant='danger'
                                            style={
                                                {color: 'red'}
                                        }>
                                            {
                                            formik.errors.rol
                                        } </Form.Text>
                                    ) : ('')
                                } </Col>
                                <Col md='4'>
                                    <Form.Label className='mt-3' style={{fontWeight: 'bold',fontSize: '14px'}}>
                                        {cfg_form21.cfg_form21['antecjudiciales-input-fechacausa']+" *"} 
                                    </Form.Label>
                                    <br/>
                                    <Form.Control className='mb-0 w-50' type='date'
                                        value={(formik.values.fechaIngresoCausa = fechaIngresoCausa)}
                                        min={fechaSiniestro && convertirFecha(fechaSiniestro && fechaSiniestro)}
                                        max={hoy()}
                                        name='fechaIngresoCausa'
                                        onChange={
                                            (e) => {
                                                formik.handleChange(e)
                                                setFechaIngresoCausa(e.target.value)
                                            }
                                        }
                                        error={
                                            formik.errors.fechaIngresoCausa
                                        }
                                    ></Form.Control>
                                    {
                                    formik.errors.fechaIngresoCausa ? (
                                    <Form.Text variant='danger' style={{color: 'red'}}>
                                        {formik.errors.fechaIngresoCausa} 
                                    </Form.Text>
                                    ) : ('')
                                    }
                                </Col>

                            <Col md='1'></Col>
                        </Row>

                        <hr style={
                            {
                                color: '#04005D',
                                height: '2px',
                                marginTop: '30px'
                            }
                        }></hr>
                        <Row>
                            <Col md='5'>
                                <Form.Label className='mb-0 mt-3'
                                    style={
                                        {
                                            fontWeight: 'bold',
                                            fontSize: '14px'
                                        }
                                }>
                                    {
                                    cfg_form21.cfg_form21['antecjudiciales-cmb-hitojudicial']
                                } </Form.Label>
                                {' '}
                                <br/>
                                <Form.Select className='mt-2' aria-label='Default select example'
                                    onChange={
                                        (e) => {
                                            formik.handleChange(e)
                                            setCodHitoJudicial(e.target.value)
                                           
                                            if (e.target.value !== '') {
                                                setIndAudiencia(comboHitoJudicial && comboHitoJudicial.comboHitoJudicial.find(c => c.id === parseInt(e.target.value)).indAudiencia)
                                                setIsHito(true)
                                            } else {
                                                setIsHito(false)

                                            }
                                        }
                                    }
                                    name='codHitoJudicial'
                                    value={
                                        (formik.values.codHitoJudicial = codHitoJudicial)
                                    }
                                    error={
                                        formik.errors.codHitoJudicial
                                }>
                                    <option value={''}>Seleccione...</option>
                                    {
                                    comboHitoJudicial && comboHitoJudicial.comboHitoJudicial ?. map((c) => (
                                        <option key={
                                                c.id
                                            }
                                            value={
                                                c.id
                                        }>
                                            {
                                            c.nombre
                                        } </option>
                                    ))
                                } </Form.Select>
                                 </Col>
                            <Col md='3'>
                                <Form.Label className='mt-3'
                                    style={
                                        {
                                            fontWeight: 'bold',
                                            fontSize: '14px'
                                        }
                                }>
                                    {
                                    cfg_form21.cfg_form21['antecjudiciales-grilla-fechaocurre'] + ' *'
                                } </Form.Label>
                                <br/>
                                <Form.Control className='mb-0' type='date'
                                    value={
                                        (formik.values.fechaHitoJudicial = fechaHitoJudicial)
                                    }
                                    min={
                                        fechaSiniestro && convertirFecha(fechaSiniestro && fechaSiniestro)
                                    }
                                    // max={hoy()}
                                    name='fechaHitoJudicial'
                                    onChange={
                                        (e) => {
                                            formik.handleChange(e)
                                            setFechaHitoJudicial(e.target.value)
                                            setFechaAudiencia('')
                                        }
                                    }
                                    error={
                                        formik.errors.fechaHitoJudicial
                                }></Form.Control>
                            {
                            formik.errors.fechaHitoJudicial ? (
                                <Form.Text variant='danger'
                                    style={
                                        {color: 'red'}
                                }>
                                    {
                                    formik.errors.fechaHitoJudicial
                                } </Form.Text>
                            ) : ('')
                        }
                         </Col>
                        <Col md='3'>
                            <Form.Label className='mt-3'
                                style={
                                    {
                                        fontWeight: 'bold',
                                        fontSize: '14px'
                                    }
                            }>
                                {
                                cfg_form21.cfg_form21['antecjudiciales-input-fechaaudiencia'] + " *"
                            } </Form.Label>
                            <br/>
                            <Form.Control className='mb-1' type='date'
                                disabled={
                                    indAudiencia === 0
                                }
                                value={
                                    (formik.values.fechaAudiencia = fechaAudiencia)
                                }
                                min={
                                    fechaHitoJudicial && fechaHitoJudicial
                                }
                                // max={hoy()}
                                name='fechaAudiencia'
                                onChange={
                                    (e) => {
                                        formik.handleChange(e)
                                        setFechaAudiencia(e.target.value)
                                    }
                                }
                                error={
                                    formik.errors.fechaAudiencia
                            }></Form.Control>
                        {
                        formik.errors.fechaAudiencia ? (
                            <Form.Text variant='danger'
                                style={
                                    {color: 'red'}
                            }>
                                {
                                formik.errors.fechaAudiencia
                            } </Form.Text>
                        ) : ('')
                    } </Col>


                    
                </Row>
                <Row>
                    <Col md='11'>
                    <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {
                          cfg_form21.cfg_form21[
                            'antecjudiciales-lbl-subirdcto'
                          ]
                        }
                      </Form.Label>
                      <Form.Group className="position-relative mb-2 mt-1">
                      <Form.Control ref={fileRef} type="file" name="file"
                          onChange={event => { formik.setFieldValue("file", event.currentTarget.files[0]); }} onBlur={formik.handleBlur}
                          isInvalid={!!formik.errors.file}
                          isValid={formik.touched.file && !formik.errors.file}
                      />
                      <Form.Text className="text-muted">Tamaño máximo del archivo: 10MB</Form.Text>
                      <Form.Control.Feedback type="invalid"> {formik.errors.file} </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  
                  </Row>
                <Row>
                    <Col md='11'>
                        <Form.Label className='mb-0 mt-3'
                            style={
                                {
                                    fontWeight: 'bold',
                                    fontSize: '14px'
                                }
                        }>
                            {
                            cfg_form21.cfg_form21['antecjudiciales-input-comentario']
                        } </Form.Label>
                        {' '}
                        <br/>
                        <Form.Control as='textarea' className='mb-2'
                            rows={2}
                            onChange={
                                (e) => {
                                    formik.handleChange(e)
                                    setMinutaHitoJudicial(e.target.value)
                                }
                            }
                            name='minutaHitoJudicial'
                            value={
                                (formik.values.minutaHitoJudicial = minutaHitoJudicial)
                            }
                            error={
                                formik.errors.minutaHitoJudicial
                            }/>
                    </Col>
                {
                formik.errors.minutaHitoJudicial ? (
                    <Form.Text variant='danger'
                        style={
                            {color: 'red'}
                    }>
                        {
                        formik.errors.minutaHitoJudicial
                    } </Form.Text>
                ) : ('')
            } </Row>
            <Row className="mt-2">
                <Col md="8"></Col>
                <Col> 
                {respuestaJudicial && 
                    <Mensajes
                        showToast={showToast}
                        handleCloseToast={handleCloseToast}
                        delay={5000}
                        responseData={respuestaJudicial?.respuestaJudicial}
                    ></Mensajes>
                }
                </Col>
            </Row>
            <hr style={
                {
                    color: '#04005D',
                    height: '2px',
                    marginTop: '10px'
                }
            }></hr>
        </div>
                        ) : null
                    } </Container>
                </Container>
            </Card>

        </>
    )
}

export default Antecedentes
